import React from 'react'

const Card = ({movie}) => {
    return (
        <>
        <div className="movie">
            <div>
                <p>{movie.Year}</p>
            </div>
            <div>
                <img src={movie.Poster !== 'N/A' ? movie.Poster : 'http://via.placeholder.com/800'} alt="movie"/>
            </div>
            <div>
                <span>{movie.Type}</span>
                <h3>{movie.Title}</h3>
            </div>
        </div>
        </>
    )
}

export default Card
